import { Directive, input } from '@angular/core';

/**
 * Estilo plano de los chips de resumen que van bajo la barra de filtros (CO-975): fondo blanco,
 * borde gris de 0,5 px y sin sombra, el mismo borde de los controles de `mhFilterTrigger`.
 * Las clases viven en constantes para que `mh-core-lib-followup-onsite-widget` use el mismo estilo
 * con su input `flat`, ya que una directiva no se puede activar o desactivar según un input.
 * Si el chip cambia el color de un solo lado (p. ej. el borde izquierdo de Facturación), ese color
 * debe ir por lado (`tw-border-l-*`) para ganarle al gris general.
 */
export const SUMMARY_CHIP_CLASSES =
  'tw-bg-white tw-border-[0.5px] tw-border-solid tw-border-border-light-gray';

/** Chip que actúa como toggle activo (p. ej. "Excluidas"): borde azul de 2 px en vez del gris. */
export const SUMMARY_CHIP_SELECTED_CLASSES = '!tw-border-2 !tw-border-main';

@Directive({
  selector: '[mhSummaryChip]',
  standalone: true,
  host: {
    class: SUMMARY_CHIP_CLASSES,
    '[class.!tw-border-2]': 'chipSelected()',
    '[class.!tw-border-main]': 'chipSelected()',
  },
})
export class SummaryChipDirective {
  /** Marca el chip como seleccionado cuando actúa como toggle. */
  readonly chipSelected = input(false);
}
